import { Box } from "theme-ui"

export default function Header({ ...otherProps }) {
  return <Box {...otherProps} />
}
